import { decode, encode } from 'html-entities';
import { config } from 'env_def';
import { apis } from '../../../config';
import { api } from '../../../api/api';
class HtmlImplApi {
    constructor() {
        this.currentURL = new URL(config('host'));
        this.name = apis.htmlApi;
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
    }
    getNodesAttributes(node) {
        try {
            const attrubutes = Array.from(node.attributes).reduce((acc, attribute) => {
                acc[attribute.name] = attribute.value;
                return acc;
            }, {});
            return JSON.stringify(attrubutes);
        }
        catch (error) {
            return '';
        }
    }
    removeRepeatedNode(head) {
        try {
            if (head === undefined || head.children.length !== 1)
                return;
            let curNode = head;
            while (curNode !== undefined && curNode.children.length === 1) {
                const nextNode = curNode.children[0];
                if (this.getNodesAttributes(curNode) === this.getNodesAttributes(nextNode)) {
                    curNode = curNode.children[0];
                }
                else {
                    break;
                }
            }
            if (head !== curNode)
                head.replaceChildren(curNode);
        }
        catch (error) {
            console.log('removeRepeatedNode', error);
        }
    }
    removeDummyNodes(root) {
        try {
            const queue = [root];
            while (queue.length > 0) {
                const node = queue.shift();
                if (node === undefined)
                    break;
                this.removeRepeatedNode(node);
                for (const child of Array.from(node.children)) {
                    queue.push(child);
                }
            }
        }
        catch (error) {
            console.log('bfs parse error:', error);
        }
    }
    parseUrl(url) {
        const exec = HtmlImplApi.UrlPattern.exec(url);
        if (exec) {
            const [whole, protocol, domain, port, path, query, hash] = exec;
            return {
                url: whole,
                protocol,
                domain,
                port: Number(port),
                path,
                query,
                hash,
            };
        }
        return undefined;
    }
    init() {
        return this.name;
    }
    encodeHtml(content) {
        return encode(content, { level: 'html5' });
    }
    decodeHtml(content) {
        return decode(content, { level: 'html5' });
    }
    parseHtml(html) {
        const a = Date.now();
        console.time(`parseHtml.${a} duration`);
        const parser = new DOMParser();
        const result = parser.parseFromString(html, 'text/html');
        console.timeEnd(`parseHtml.${a} duration`);
        return result;
    }
    mergeHtmlStr(prefixHtml, suffixHtml) {
        if (!/\<\s*\/\s*body\s*\>|\<\s*\/\s*html\s*\>/gi.test(prefixHtml + suffixHtml)) {
            return prefixHtml + suffixHtml;
        }
        const originDom = this.parseHtml(prefixHtml);
        const appendDom = this.parseHtml(suffixHtml);
        const originBody = originDom.body;
        const appendBody = appendDom.body;
        const fragment = document.createDocumentFragment();
        if (prefixHtml) {
            fragment.appendChild(document.createElement('div'));
        }
        Array.prototype.slice.call(appendBody.childNodes).forEach(_ => {
            fragment.appendChild(_);
        });
        originBody.appendChild(fragment);
        const resultDomStr = originDom.documentElement.outerHTML;
        return resultDomStr;
    }
    transferHtml(html, transfer, config) {
        let element;
        if (typeof html === 'string') {
            const document = this.parseHtml(html);
            element = document.documentElement;
        }
        else if (typeof html === 'object' && html instanceof Document) {
            element = html.documentElement;
        }
        else if (typeof html === 'object' && html instanceof Element) {
            element = html;
        }
        if (!element)
            return '';
        this.walkElementTree(element, transfer, config);
        return element.innerHTML;
    }
    walkElementTree(parent, transfer, config, depth = 0) {
        if (parent.children && parent.childElementCount > 0) {
            const childrenArr = Array.from(parent.children || []);
            Object.keys(childrenArr.splice(0, 5000)).forEach(k => {
                const idOfC = Number(k);
                if (Object.prototype.hasOwnProperty.apply(parent.children, [idOfC]) && parent.children[idOfC]) {
                    let el = parent.children[idOfC];
                    if (depth > 1280) {
                        const { ownerDocument } = parent;
                        if (ownerDocument) {
                            const newEl = ownerDocument.createElement('div');
                            newEl.insertAdjacentText('afterbegin', el.innerText);
                            parent.replaceChild(newEl, el);
                        }
                        else {
                            parent.removeChild(el);
                            el = undefined;
                        }
                        return;
                    }
                    let operation = null;
                    try {
                        operation = transfer(el, config);
                    }
                    catch (e) {
                        console.error('[html transfer error]', e);
                    }
                    if (operation) {
                        if (operation.op === 'remove') {
                            parent.removeChild(el);
                            el = undefined;
                        }
                        if (operation.op === 'replace' && operation.el && el) {
                            parent.replaceChild(operation.el, el);
                            el = undefined;
                        }
                        else if (operation.op === 'wrapAndReplace' && operation.el && el) {
                            operation.el.append(el);
                            parent.replaceChild(operation.el, el);
                            el = operation.el;
                        }
                        else if (el && (operation.op === 'append' || operation.op === 'prepend') && operation.newEl && operation.newEl.length > 0) {
                            operation.newEl.forEach(it => {
                                if (operation) {
                                    if (operation.op === 'append') {
                                        el.append(it);
                                    }
                                    else {
                                        el.prepend(it);
                                    }
                                }
                            });
                        }
                    }
                    if (el) {
                        this.walkElementTree(el, transfer, config, depth + 1);
                    }
                }
            });
        }
    }
    generateElStr(doc) {
        let str = '';
        const filteredIds = ['lingxi-signature-block'];
        function loopEl(el) {
            const { localName, attributes, innerText, children, id } = el;
            if (filteredIds.includes(id))
                return;
            const text = ['body'].includes(localName) ? innerText.replace(/\n/g, '') : innerText;
            str += ` tag:${localName} innerText:${text}`;
            const filteredAttrs = ['style'];
            attributes &&
                Array.from(attributes).forEach(attr => {
                    if (!filteredAttrs.includes(attr.name)) {
                        str += ` ${attr.name}:${attr.value}`;
                    }
                });
            children &&
                Array.from(children).forEach(child => {
                    loopEl(child);
                });
        }
        loopEl(doc.body);
        return str;
    }
    parseUrlQuery(urlInput) {
        let url = urlInput;
        const ret = {};
        try {
            if (url && url.length > 2) {
                if (url.startsWith('//')) {
                    url = this.currentURL.protocol + url;
                }
                else if (url.startsWith('/')) {
                    url = this.currentURL.origin + url;
                }
                const urlLower = url.toLowerCase();
                if (urlLower.startsWith('http')) {
                    const parsedUrl = new URL(url);
                    const { search } = parsedUrl;
                    const searchParams = new URLSearchParams(search);
                    searchParams.forEach((v, k) => {
                        ret[k] = v;
                    });
                }
            }
            return ret;
        }
        catch (e) {
            console.error('[parseUrlQuery error]', e);
            return ret;
        }
    }
}
HtmlImplApi.UrlPattern = /^((?:https?)|(?:file)|(?:mailto)):\/\/([a-z0-9_\-.]{0,256})(:[0-9]{2,5})?\/([a-z0-9_\-.\/]*)(?:\?([^#?\\\/]+))?(?:#([^\s]*))?$/i;
const htmlApi = new HtmlImplApi();
api.registerLogicalApi(htmlApi);
export default htmlApi;
